import { useStaticQuery, graphql } from "gatsby"

export const useTouQuery = () => {


    const data = useStaticQuery(graphql`
    query TouQuery {
        wpPage(title: {eq: "TERMS OF USE"}) {
            ACF_TermsOfUsePage {
                touHeader {
                    image{
                        publicUrl
                    }
                    title
                }
                touContent {
                    content
                }

                touMetaData {
                    metaTitle
                    metaDescription
                }
        }
        }
    }     
    `)
    return data.wpPage.ACF_TermsOfUsePage;
}